<template>
  <div
    class="product-filter-modal"
    v-if="showFilterModal"
    :class="{'active': filterModalActive}"
  >
    <div class="container">
      <div
        class="header"
      >
        <span
          @click="closeModal"
          class="close-filter-modal-button"
        >Kapat</span>
        <span>Filtre</span>
      </div>
      <div class="inputs">
        <div>
          Kategori
          <CategorySelect
            v-model="filterNames.category"
            name="productCategory"
            @categoryFilter="categoryFilter"
            :options="getCategoriesList"
            placeholder="Kategori Seçimi"
          />
        </div>
        <div>
          Marka
          <BrandSelect
            v-model="filterNames.brand"
            @brandFilter="brandFilter"
          />
        </div>
      </div>
      <div class="button-container">
        <GButton
          class="clear-button"
          @click="onClear"
        >
          Temizle
        </GButton>
        <GButton
          class="submit-button"
          @click="onFilter"
        >
          Filtrele
        </GButton>
      </div>
    </div>
  </div>
</template>
<script>
import GButton from '@trendyol-js/grace/core/GButton';
import CategorySelect from '@/pages/AddFromCatalog/Components/CategorySelect';
import categoryService from '@/services/category';
import BrandSelect from '@/pages/AddFromCatalog/Components/BrandSelect';

export default {
  name: 'FilterModal',
  components: { BrandSelect, CategorySelect, GButton },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    params: {
      type: Object,
      default: () => {},
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      showFilterModal: false,
      filterModalActive: false,
      filterModalActiveCloseBtn: false,
      filterNames: {
        category: [],
        brand: [],
      },
      categories: [],
      subModalOpen: false,
      vatRateOptions: [
        {
          text: '%0',
          value: '0',
        },
        {
          text: '%1',
          value: '1',
        },
        {
          text: '%10',
          value: '10',
        },
        {
          text: '%20',
          value: '20',
        },
      ],
    };
  },
  computed: {
    getCategoriesList () {
      return this.categories;
    },
  },
  methods: {
    async getCategories () {
      const response = await categoryService.getFlattenCategories();
      this.categories = response;
    },
    closeModal () {
      this.$emit('close');
    },
    onFilter () {
      this.$emit('filter', this.params, this.filterNames);
    },
    onClear () {
      this.params = {
        ...this.params,
        categoryIds: [],
        brandIds: [],
      };
      this.filterNames = {
        category: [],
        brand: [],
      };
      this.onFilter();
    },
    categoryFilter (categories, categoryNames) {
      this.params.categoryIds = categories;
      this.filterNames.category = categoryNames;
    },
    brandFilter (brands, brandNames) {
      this.params.brandIds = brands;
      this.filterNames.brand = brandNames;
    },
  },
  async created () {
    this.params.barcode = this.$route.query.barcode ? this.$route.query.barcode : null;
    if (this.params.barcode) {
      this.handleFilter();
    }
    await this.getCategories();
    this.defaultParams = this.params;
  },
  watch: {
    show () {
      this.showFilterModal = this.show;
      this.filterNames = this.filters;
    },
  },
};
</script>
<style lang="scss" scoped>
.product-filter-modal {
  z-index: 1;
  position: fixed;
  background: #273142;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  transition: all ease .1s;
  .container {
    border-radius: 12px 12px 0 0;
    background: white;
    height: 100vh;
    .header {
      display: flex;
      height: 40px;
      padding: 0 20px;
      align-items: center;
      gap: calc((100% / 2) - 60px);
      .close-filter-modal-button {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #FF5043;
      }
    }
  }
  .inputs {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 15px;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #6E7787;
    div {
      display: flex;
      flex-direction: column;
      gap: 5px;
      ::v-deep .g-input {
        .content {
          border: 1px solid #D5D9E1;
          border-radius: 6px;
        }
      }
    }
  }
  ::v-deep .modal-container {
    .modal {
      height: 100% !important;
      border-radius: 12px 12px 0 0;
    }
  }
  ::v-deep .input-group {
    input {
      border: 1px solid #D5D9E1;
      height: 40px;
      border-radius: 6px;
    }
  }
  .button-container {
    position: absolute;
    display: flex;
    gap: 15px;
    width: 100%;
    bottom: 0;
    padding: 15px;
    color: white;
    height: 80px;
    .submit-button {
      width: 65%;
      background: #F27A1A;
      border-radius: 6px;
    }
    .clear-button {
      width: 30%;
      background: #AFBBCA;
      border-radius: 6px;
    }
  }
}
</style>
